import { HtmlConnected as Html } from '../html'

export const SignupClosed = ({ project }) => (
  <Html name="signup-closed" data={{ project }} />
)
